import { Component, Input } from '@angular/core';
import {
  FundPerformanceDates,
  FundPerformanceCumulativeTableData,
  FundPerformanceCumulativeStateConfig,
} from '@products/types/performance.type';
import { FundPerformanceComponentConfig } from '@products/fund-performance/fund-performance-component.config';
import { FundId } from '@types';
import { BaseTableResponsiveComponent } from '@shared/table/base-table-responsive.component';
import { ResponsiveService } from '@frk/eds-components';

@Component({
  selector: 'ft-fund-performance-cumulative-table',
  templateUrl: './fund-performance-cumulative-table.component.html',
  styleUrls: ['./fund-performance-cumulative-table.component.scss'],
})
export class FundPerformanceCumulativeTableComponent extends BaseTableResponsiveComponent {
  @Input() fundPerformanceData: FundPerformanceCumulativeTableData[];
  @Input() fundPerformanceConfig: FundPerformanceCumulativeStateConfig;
  @Input() fundPerformanceDates: FundPerformanceDates;
  @Input() tableLabel: string;
  @Input() fundId: FundId;
  @Input() isAllShareClasses: boolean;
  @Input() showLegends = true;
  @Input() containerId?: string;

  constructor(protected responsiveService: ResponsiveService) {
    super(responsiveService);
  }
}
